// Shared by the full contact page and product inquiry modal.
export const PRODUCT_INQUIRY_FIELD_NAMES = {
  productName: "product_name",
  sourceProductSku: "Source Product SKU",
  estimatedOrderQuantity: "Estimated Order Quantity",
  packagingType: "Packaging Type",
  expectedLaunchDate: "Expected Launch Date",
  needs: "What Do You Need",
};

export const estimatedOrderQuantityOptions = [
  "1,000–2,999 retail units",
  "3,000–4,999 retail units",
  "5,000–9,999 retail units",
  "10,000+ retail units",
  "Not sure yet",
];

export const packagingTypeOptions = [
  "Paper Box",
  "Paper Envelope",
  "Pouch / Bag",
  "Bottle / Jar / Tub",
  "Bulk / Refill",
  "Need Recommendation",
  "Other",
];

export const needOptions = [
  "Samples",
  "Quote",
  "Custom Formula",
  "Packaging Support",
];

export const normalizeProductInquiryFields = (formData) => {
  const productName = String(formData.get(PRODUCT_INQUIRY_FIELD_NAMES.productName) || "").trim();
  formData.set(PRODUCT_INQUIRY_FIELD_NAMES.productName, productName || "General product inquiry");

  const selectedNeeds = formData
    .getAll(PRODUCT_INQUIRY_FIELD_NAMES.needs)
    .filter(Boolean);

  if (selectedNeeds.length) {
    formData.set(PRODUCT_INQUIRY_FIELD_NAMES.needs, selectedNeeds.join(", "));
  }

  // Web3Forms renders each field in the email. Keep details in their own fields
  // and leave the buyer's message untouched to avoid repeating the same content.
  return formData;
};
